/**
 * maestroSurface
 *
 * Purpose: The one style for a Maestro-owned, read-only area (ORCH-426). The
 *   panel's design rule is "outline means you can type here; shading means it
 *   belongs to Maestro or is read-only": the field card, the status messages
 *   ("Waiting for Maestro…", "Ready — please attach a media brief."), the
 *   progress line and the question cards all take the shared `maestro.surface`
 *   palette fill and draw no border, while the form inputs rendered inside
 *   them keep their outline.
 *
 * Architecture: A plain `sx` fragment rather than a component, so it can be
 *   spread onto whatever element already carries a `data-testid` (the progress
 *   line, the active-field card) without changing the DOM the specs read.
 *   The colour itself lives on the theme (`palette.maestro.surface`), not here.
 *
 * Dependencies: theme `maestro.surface` token (orchestrateTheme.ts).
 */

import type { SxProps, Theme } from '@mui/material/styles';

/** Light gray fill, rounded, no border — spread onto any Maestro status area. */
export const maestroSurfaceSx: SxProps<Theme> = {
  bgcolor: 'maestro.surface',
  border: 'none',
  borderRadius: 1,
  px: 1.25,
  py: 1,
};
